module.exports = __webpack_public_path__ + "static/media/signin-background.ea9f8779.jpg";